import { cn } from '../../../utils/cn'

/** Income reads as a figure, Experience as a plain sentence, so the weights differ. */
const VALUE_STYLES = {
  figure: 'font-semibold leading-normal',
  plain: 'font-medium leading-[1.5] tracking-[-0.352px]',
} as const

type DriverStatProps = {
  label: string
  value: string
  emphasis: keyof typeof VALUE_STYLES
}

export const DriverStat = ({ label, value, emphasis }: DriverStatProps) => (
  <div className="flex w-full flex-col items-start gap-[3px] font-host">
    <span className="h-[19px] w-full truncate text-[14px] font-medium leading-[1.5] tracking-[-0.308px] text-dash-driver-name">
      {label}
    </span>
    <span className={cn('w-full truncate text-[16px] text-black', VALUE_STYLES[emphasis])}>
      {value}
    </span>
  </div>
)
